import { useCallback, useRef } from "react";
import { useIsMobile } from "../../hooks/useIsMobile";
import { useMobileEdgeChromeStore } from "../../stores/mobileEdgeChromeStore";
import {
  MOBILE_VIEWPORT_BLANK_TAP_MAX_MS,
  MOBILE_VIEWPORT_BLANK_TAP_MAX_PX,
} from "../scene/sceneConstants";

export function useMobileViewportBlankTap({
  setActiveSubmenu,
  setSceneAddGeomKindSubmenuOpen,
  setSceneAddJointKindSubmenuOpen,
  setSceneAddVisualGeomKindSubmenuOpen,
  setSceneContextMenuOpen,
}) {
  const isMobile = useIsMobile();
  const immersiveLibraryDrag = useMobileEdgeChromeStore((s) => s.immersiveLibraryDragActive);
  const blankTapRef = useRef(null);

  const onPointerDownCapture = useCallback(
    (event) => {
      if (!isMobile || immersiveLibraryDrag) return;
      if (event.button !== 0) return;
      blankTapRef.current = { x: event.clientX, y: event.clientY, t: performance.now() };
    },
    [isMobile, immersiveLibraryDrag]
  );

  const onPointerUpCapture = useCallback(
    (event) => {
      if (!isMobile || immersiveLibraryDrag) return;
      if (event.button !== 0) return;
      const start = blankTapRef.current;
      blankTapRef.current = null;
      if (!start) return;
      const dt = performance.now() - start.t;
      const dx = event.clientX - start.x;
      const dy = event.clientY - start.y;
      if (
        dt > MOBILE_VIEWPORT_BLANK_TAP_MAX_MS ||
        Math.hypot(dx, dy) > MOBILE_VIEWPORT_BLANK_TAP_MAX_PX
      ) {
        return;
      }
      setSceneContextMenuOpen(false);
      setActiveSubmenu(null);
      setSceneAddJointKindSubmenuOpen(false);
      setSceneAddGeomKindSubmenuOpen(false);
      setSceneAddVisualGeomKindSubmenuOpen(false);
      window.dispatchEvent(new CustomEvent("mobile-viewport-blank-tap"));
    },
    [
      isMobile,
      immersiveLibraryDrag,
      setActiveSubmenu,
      setSceneAddGeomKindSubmenuOpen,
      setSceneAddJointKindSubmenuOpen,
      setSceneAddVisualGeomKindSubmenuOpen,
      setSceneContextMenuOpen,
    ]
  );

  const onPointerCancelCapture = useCallback(() => {
    blankTapRef.current = null;
  }, []);

  return {
    onPointerCancelCapture,
    onPointerDownCapture,
    onPointerUpCapture,
  };
}
